import React from 'react';
import 'pages/Dogs/Dogs.css';
import DogCard from 'components/DogCard/DogCard';
import useDogsData from 'pages/Dogs/hooks/useDogsData';
import LoadingView from 'components/LoadingView';

function Dogs() {
    const [dogsData, loading] = useDogsData() || [];

    if (loading) return <LoadingView />;

    return (
        <section className={'dogs'}>
            <div className={'stripes-bg'}>
                <div className={'dogs-list '}>
                    {dogsData?.docs?.map(dogRef => (
                        <DogCard dogRef={dogRef} id={dogRef.id} key={dogRef.id} />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Dogs;
